function clearTag(str) {
	if(!str) return ''
	return str.replace(/<\/?.+?\/?>/g, "").replace(/&nbsp;/g, '').replace(/■/g, '')
}
export { clearTag }


// WEBPACK FOOTER //
// ./src/utils/util.js